import { Wording } from '@/types';

export const COOKING_WORDING_DK: Wording = {
  components_header_media_content: 'Madlavningsvideoer',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Opskrifter',
  components_header_text2: 'Blog',
  components_header_members: 'Medlemmer',
  hero_text: 'Lav mad med passion, spis med glæde',
  hero_button_text: 'Start med at lave mad i dag',
  components_ressources_section_title: 'RESSOURCER',
  components_ressources_subheader_text: 'Alle de ressourcer, du har brug for til at lære, lave mad og skabe bedre mad',
  components_ressources_span_text: 'Oplev en rig samling af videoopskrifter, detaljerede madlavningsguider og ekspertindsigt i smagskombinationer, madpræsentation og kulinarisk kreativitet.',
  components_ressources_card_1_title: 'Madlavningsinspiration',
  components_ressources_card_1_text: 'Bliv inspireret af kreative opskrifter og madlavningsvideoer.',
  components_ressources_card_2_title: 'Madlavningsviden',
  components_ressources_card_2_text: 'Lær essentielle madlavningsteknikker, smagskombinationer og det grundlæggende i madparring gennem klare og praktiske guider.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Madlavningsuddannelse',
  components_notes_and_google_title_2: 'Hverdagsmadlavning',
  components_notes_and_google_title_3: 'Konsekvente madlavningsevner',
  components_review_google_text: 'Anmeldelser på Google',
  media_content_section_title: 'Madlavningsvideoer',
  media_content_section_subheader_text: 'Udforsk opskrifter og trin-for-trin madlavningsvideoer.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Guider og artikler',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPSKRIFTER',
  components_text1_subheader_text: 'Lækre opskrifter til hverdagsmadlavning',
  components_text1_span_text: 'Opdag nemme opskrifter designet til hverdagsmåltider, klare trin og fantastiske resultater.',
  components_text1_card_1_title: 'Start din dag rigtigt',
  components_text1_card_1_text: 'Enkle og lækre opskrifter til at starte dagen med lethed og smag.',
  components_text1_card_3_title: 'Smagfulde frokostidéer',
  components_text1_card_3_text: 'Lækre frokostopskrifter, der er nemme at tilberede og fulde af smag.',
  components_text1_card_2_title: 'Trøstende middagsopskrifter',
  components_text1_card_2_text: 'Varme, mættende aftensmadsopskrifter, perfekte til afslappede aftener derhjemme.',
  components_text1_link: 'Se alle opskrifter',
  components_footer_text: 'Lær bedre madlavning, skab bedre mad: Dit køkken, din rejse.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Privatlivspolitik',
  button_load_more: 'Indlæs mere',
  page_media_1_content_hero_text: 'Opdag nemme madlavningsvideoer for enhver smag',
  page_text1_hero_text: 'Opskrifter',
  page_text1_section_title: 'Madlavningstips',
  page_text1_subheader_text: 'Opskrifter',
  page_text2_hero_text: 'Vores blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Guider og artikler',
  enter_email_title: 'Indtast venligst din e-mail for at fortsætte',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Indtast',
  components_login_success_text: 'Login lykkedes!',
  components_card_link_media_content: 'Se nu',
  components_card_link_text1_content: 'Se opskrift',
  components_card_link_text2_content: 'Se artikel',
};